import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderService } from 'app/services/header/header.service';
import {
  GestionStockTabCounts,
  LogicielCaisseGestionStockStateService,
} from 'app/services/logiciel-caisse/logiciel-caisse-gestion-stock-state.service';

export type GestionStockTab = 'actif' | 'archive';

@Component({
  selector: 'app-logiciel-caisse-gestion-stock',
  templateUrl: './logiciel-caisse-gestion-stock.component.html',
  styleUrls: ['./logiciel-caisse-gestion-stock.component.scss'],
})
export class LogicielCaisseGestionStockComponent implements OnInit, OnDestroy {
  currentTab: GestionStockTab = 'actif';
  counts: GestionStockTabCounts = { actif: 0, archive: 0 };
  /** Sous /main/parametre : le header est déjà fourni par le layout Paramètres. */
  embeddedInParametre = false;

  private routeSub?: Subscription;
  private countsSub?: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly headerService: HeaderService,
    private readonly stockState: LogicielCaisseGestionStockStateService
  ) {}

  ngOnInit(): void {
    this.embeddedInParametre = this.router.url.includes('/main/parametre/');
    this.headerService.setConfig({ title: 'Gestion stock', buttons: [] });
    this.countsSub = this.stockState.counts$.subscribe((c) => {
      this.counts = c;
    });
    this.routeSub = this.route.firstChild?.url.subscribe((segments) => {
      const path = segments.length > 0 ? segments[0].path : 'actif';
      this.currentTab = path === 'archive' ? 'archive' : 'actif';
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.countsSub?.unsubscribe();
  }

  filterByTab(tab: GestionStockTab): void {
    this.currentTab = tab;
    void this.router.navigate([tab], { relativeTo: this.route });
  }
}
